import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Forum from "@/pages/Forum";
import ThreadDetail from "@/pages/ThreadDetail";
import CreateThread from "@/pages/CreateThread";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Rules from "@/pages/Rules";
import Subscribe from "@/pages/Subscribe";
import FirearmsVerify from "@/pages/FirearmsVerify";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import AdminReports from "@/pages/AdminReports";
import { Footer } from "@/components/Footer";
import { Navigate } from "react-router-dom";

const Layout = () => (
  <>
    <Header />
    <div className="min-h-[calc(100vh-4rem)] flex flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  </>
);

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forum" element={<Forum />} />
        <Route path="/threads/new" element={<RequireAuth><CreateThread /></RequireAuth>} />
        <Route path="/threads/:id" element={<ThreadDetail />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/listings/new" element={<RequireAuth><CreateListing /></RequireAuth>} />
        <Route path="/listings/:id" element={<ListingDetail />} />
        <Route path="/messages" element={<RequireAuth><Messages /></RequireAuth>} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/firearms/verify" element={<RequireAuth><FirearmsVerify /></RequireAuth>} />
        <Route path="/subscription/success" element={<RequireAuth><SubscriptionSuccess /></RequireAuth>} />
        <Route path="/admin/reports" element={<RequireAuth><AdminReports /></RequireAuth>} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
